export const SET_UI = 'SET_UI';
export const UI_SET_LOADER = 'UI_SET_LOADER';
export const UI_GET_MASTER_DATA = 'UI_GET_MASTER_DATA';
export const UI_UPDATE_MASTER_DATA = 'UI_UPDATE_MASTER_DATA';
export const UI_GET_TOWNS_BY_CP = 'UI_GET_TOWNS_BY_CP';
export const UI_UPDATE_TOWNS_BY_CP_CACHE = 'UI_UPDATE_TOWNS_BY_CP_CACHE';
export const UI_SET_SHOWROOM_TYPE = 'UI_SET_SHOWROOM_TYPE';
export const UI_SET_PAGINATION_FILTER = 'UI_SET_PAGINATION_FILTER';
export const UI_SET_OPERATIONS_FILTER = 'UI_SET_OPERATIONS_FILTER';
export const UI_SET_EXPIRATIONS_FILTER = 'UI_SET_EXPIRATIONS_FILTER';
export const UI_SET_COMMON_FILTER = 'UI_SET_COMMON_FILTER';
export const UI_RESET_COMMONS_FILTERS = 'UI_RESET_COMMONS_FILTERS';
export const UI_GET_SECTION_FILTERS = 'UI_GET_SECTION_FILTERS';
export const UI_SET_SECTION_FILTERS = 'UI_SET_SECTION_FILTERS';
export const UI_RESET_SECTION_FILTERS = 'UI_RESET_SECTION_FILTERS';
export const GOTO_EXTERNAL_URL = 'GOTO_EXTERNAL_URL';
export const UI_SET_SECTION_FILTERS_FIELDS = 'UI_SET_SECTION_FILTERS_FIELDS';
export const UI_SET_RESET_SECTION = 'UI_SET_RESET_SECTION';
export const UI_SET_CAMPAIGN_EDIT_FIELDS = 'UI_SET_CAMPAIGN_EDIT_FIELDS';
export const UI_GET_CAMPAIGN_EDIT_FIELDS = 'UI_GET_CAMPAIGN_EDIT_FIELDS';
export const UI_GET_SECTION_MENU = 'UI_GET_SECTION_MENU';
export const UI_SET_SECTION_MENU = 'UI_SET_SECTION_MENU';
export const UI_SET_SECTION_MENU_ACTION = 'UI_SET_SECTION_MENU_ACTION';
export const UI_GET_VEHICLE_MARKS = 'UI_GET_VEHICLE_MARKS';
export const UI_SET_VEHICLE_MARKS = 'UI_SET_VEHICLE_MARKS';
export const UI_GET_VEHICLE_MODELS = 'UI_GET_VEHICLE_MODELS';
export const UI_SET_VEHICLE_MODELS = 'UI_SET_VEHICLE_MODELS';
export const UI_GET_VEHICLE_VERSION = 'UI_GET_VEHICLE_VERSION';
export const UI_SET_VEHICLE_VERSION = 'UI_SET_VEHICLE_VERSION';
export const UI_GET_VEHICLE_STYLE_BODY = 'UI_GET_VEHICLE_STYLE_BODY';
export const UI_SET_VEHICLE_STYLE_BODY = 'UI_SET_VEHICLE_STYLE_BODY';
export const UI_RESET_VEHICLE_MODELS = 'UI_RESET_VEHICLE_MODELS';
export const UI_RESET_VEHICLE_BODY_STYLES = 'UI_RESET_VEHICLE_BODY_STYLES';
export const UI_SET_API_BUSY = 'UI_SET_API_BUSY';
export const UI_SET_LOADER_MODAL = 'UI_SET_LOADER_MODAL';
export const UI_SET_LOADER_TEXT_MODAL = 'UI_SET_LOADER_TEXT_MODAL';
export const UI_IMAGES_BENCH_MASTER_DATA = 'UI_IMAGES_BENCH_MASTER_DATA';
export const UI_GET_VEHICLE_ZONE = 'UI_GET_VEHICLE_ZONE';
export const UI_SET_VEHICLE_LOCATION = 'UI_SET_VEHICLE_LOCATION';
export const UI_GET_IMAGES_BENCH_VEHICLE_BRAND = 'UI_GET_IMAGES_BENCH_VEHICLE_BRAND';
export const UI_GET_IMAGES_BENCH_VEHICLE_MODELS = 'UI_GET_IMAGES_BENCH_VEHICLE_MODELS';
export const UI_GET_IMAGES_BENCH_VEHICLE_VERSION = 'UI_GET_IMAGES_BENCH_VEHICLE_VERSION';
export const UI_GET_IMAGES_BENCH_VEHICLE_OPTIONS = 'UI_GET_IMAGES_BENCH_VEHICLE_OPTIONS';
export const UI_SET_VEHICLE_OPTIONS = 'UI_SET_VEHICLE_OPTIONS';
export const SHOW_MAIN_NOTIFICATION = 'SHOW_MAIN_NOTIFICATION';
export const CLEAR_MAIN_NOTIFICATION = 'CLEAR_MAIN_NOTIFICATION';
export const UI_SET_LIST_ID_OPTIONS = 'UI_SET_LIST_ID_OPTIONS';
